import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import {AppBar, Box, Button, Container, Grid, Hidden, Typography} from '@material-ui/core';

const useStyles = makeStyles( theme => ({
    root: {
        [theme.breakpoints.down('md')] : {
            height: 200,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        height: 300,
    },
    container: {
        // margin: '50px 0'
        // height: 200,
        // border: '1px solid red'
    },
    button: {
        color: 'white',
        minHeight: 40,
        width: '10%',
        // marginBottom: 30,
    },
    rightAngleGraphic1: {
        zIndex: '1',
        position: 'relative',
        top: 0,
        left: -580,
        height: 80,
        width: 80,
        borderRight: `5px solid ${theme.palette.primary.dark}`,
        borderBottom: `5px solid ${theme.palette.primary.dark}`,
        transform: "rotate(-180deg)",
    },
    rightAngleGraphic2: {
        zIndex: '1',
        position: 'relative',
        top: 0,
        left: 580,
        height: 80,
        width: 80,
        borderRight: `5px solid ${theme.palette.primary.dark}`,
        borderBottom: `5px solid ${theme.palette.primary.dark}`,
    },
}));

const ContactPage = () => {

    const classes = useStyles();

    return (
        <Container maxWidth="lg" className={classes.root}>
            <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.container}>
                <Hidden mdDown>
                    <div className={classes.rightAngleGraphic1}></div>
                </Hidden>
                <Grid item xs={12}>
                    <Grid container justifyContent="center">
                        <Typography color="textPrimary" variant="h5" gutterBottom>
                            Let's get in touch
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container justifyContent="center">
                        <Typography color="textPrimary" variant="subtitle1" gutterBottom>
                            you can contact me by email
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12}>   
                    <Grid container justifyContent="center">
                        <Button variant="contained" size="small" color="primary" className={classes.button}>
                            contact
                        </Button>
                    </Grid>
                </Grid>
                <Hidden mdDown>
                    <div className={classes.rightAngleGraphic2}></div>
                </Hidden>
            </Grid>
        </Container>
    )
}

export default ContactPage
